function AlertExceptionRegionCell(props) {
    return <>{props.value?.label ?? "-"}</>;
}

export default AlertExceptionRegionCell;
